import { Skeleton } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { MdChevronLeft } from "react-icons/md";
import SectionHeader from "components/layout/SectionHeader";

const QueueSection = ({
  title,
  count,
  loading,
  items,
  renderItem,
  emptyText = "لا يوجد عناصر معلقة",
  viewAllLink,
  viewAllLabel = "عرض الكل",
}) => {
  return (
    <section className="flex flex-col gap-3 rounded-2xl border border-border-muted bg-surface-muted p-4 dark:border-navy-700 dark:bg-navy-900">
      <SectionHeader
        title={title}
        count={count}
        action={
          viewAllLink ? (
            <Link
              to={viewAllLink}
              className="inline-flex items-center gap-1 text-xs font-semibold text-info-600 hover:text-info-700"
            >
              {viewAllLabel}
              <MdChevronLeft className="h-4 w-4" />
            </Link>
          ) : null
        }
      />
      <div className="flex flex-col gap-2">
        {loading ? (
          <>
            <Skeleton height="62px" borderRadius="12px" />
            <Skeleton height="62px" borderRadius="12px" />
            <Skeleton height="62px" borderRadius="12px" />
          </>
        ) : items && items.length > 0 ? (
          items.map((item, idx) => renderItem(item, idx))
        ) : (
          <div className="rounded-xl border border-dashed border-border bg-white px-4 py-6 text-center text-sm text-gray-500 dark:border-navy-700 dark:bg-navy-800">
            {emptyText}
          </div>
        )}
      </div>
    </section>
  );
};

export default QueueSection;
